// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Sule',
  error: () => 'Tõrge',
  warn: () => 'Hoiatus',
  info: () => 'Teave',
  confirmation: () => 'Kinnitus',
  progressIndeterminate: () => 'Pooleli',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Vahemikus ' + p['FROM_SECTION'] + ' ja ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Vastavat jaotist ei leitud.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Väärtuse valimiseks vajutage sisestusklahvi.',
  indexer_touchInstructionText: () =>
    'Topeltpuudutage ja hoidke žestirežiimi aktiveerimisekst ning seejärel lohistage väärtuse kohandamiseks üles või alla.',
  inputPassword_show: () => 'Kuva parool',
  inputPassword_hide: () => 'Peida parool',
  inputPassword_hidden: () => 'Parool on peidetud',
  formControl_clear: () => 'Tühjenda',
  formControl_loading: () => 'Laadimine',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimumpikkus ' + p['MAX_LENGTH'] + ' on ületatud.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Järele on jäänud ' + p['CHARACTER_COUNT'] + ' märki.',
  formControl_requiredMessageDetail: () => 'Sisestage väärtus.',
  select_requiredMessageDetail: () => 'Valige väärtus.',
  select_noMatchesFound: () => 'Vasteid ei leitud.',
  select_oneMatchFound: () => 'Leiti üks vaste',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Leiti ' + p['TOTAL_SIZE'] + ' vastet',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Leiti ' + p['TOTAL_SIZE'] + ' või rohkem vastet',
  selectMultiple_selectedValues: () => 'Valitud väärtused',
  selectMultiple_showSelectedValues: () => 'Kuva ainult valitud väärtused.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Valitud on ' + p['VALUE_COUNT'] + ' väärtust.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Valitud väärtuse eemaldamiseks vajutage tagasilükkeklahvi või klahvi Kustuta.',
  selectMultiple_apply: () => 'Rakenda',
  selectMultiple_back: () => 'Tagasi',
  selector_selected: () => 'Märkeruut on märgitud',
  selector_unselected: () => 'Märkeruut pole märgitud',
  userAssistance_learnMore: () => 'Lisateave',
  userAssistance_required: () => 'Kohustuslik',
  filePicker_singleFileUploadError: () => 'Üles saate korraga laadida ühe faili',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Te ei saa üles laadida faile tüübiga ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Te ei saa üles laadida faile tüübiga ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'tundmatu',
  filePicker_dropzonePrimaryText: () => 'Pukseeri',
  filePicker_dropzoneSecondaryText: () => 'Valige fail või pukseerige see siia',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Valige failid või pukseerige need siia',
  filePicker_addFiles: () => 'Lisa failid',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Suurendamine',
  inputNumber_decrease: () => 'Vähendamine',
  inputNumber_converterParseError: () => 'Sisestage number.',
  noData_message: () => 'Kuvatavaid üksusi pole',
  message_navigationFromMessagesRegion: () =>
    'Sõnumite alasse liikumine. Eelmisele fookuses olnud elemendile tagasiliikumiseks vajutage klahvi F6.',
  message_navigationToMessagesRegion: () =>
    'Sõnumite alal on uusi sõnumeid. Viimatise sõnumi alale liikumiseks vajutage klahvi F6.',
  messageToast_allMessagesClosed: () => 'Kõik töölaua sõnumid on suletud.',
  expandableList_groupCollapse: () => 'Ahendatud',
  expandableList_groupExpand: () => 'Laiendatud',
  expandableList_expandCollapseInstructionText: () =>
    'Kasutage laiendamiseks ja ahendamiseks nooleklahve',
  list_suggestion: () => 'Soovitus',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Samm ' + p['currentStep'] + '/' + p['numberOfSteps'],
  train_current: () => 'Praegune',
  train_visited: () => 'Külastatud',
  train_not_visited: () => 'Pole külastatud',
  train_message_type: () => 'Sõnumitüüp',
  viz_drillable: () => 'Süvitsiminekuks sobiv',
  dataVisualization_stateSelected: () => 'Valitud',
  dataVisualization_stateUnselected: () => 'Valimata',
  dataVisualization_noData: () => 'Kuvatavaid andmeid pole'
};
export default bundle;
